import React from 'react';
import { Link } from 'react-router-dom';
import { CreditCard, ArrowRight, Calendar } from 'lucide-react';
import ClientPageLayout from '../../components/shared/layouts/ClientPageLayout';

/**
 * Card details are not stored on vendaList — payments run through Stripe checkout
 * at booking/invoice time. This page is intentionally light until saved methods exist.
 */
const ClientBilling = () => {
 return (
 <ClientPageLayout
 title="Billing"
 subtitle="Payments are processed securely through Stripe when you book or pay an invoice."
 guideKey="billing"
 >
 <div className="space-y-5">
 <div className="product-panel p-6 sm:p-8">
 <div className="flex flex-col sm:flex-row sm:items-start gap-4">
 <div className="w-12 h-12 rounded-xl bg-surface-muted border border-border flex items-center justify-center flex-shrink-0">
 <CreditCard className="w-6 h-6 text-ink" />
 </div>
 <div className="min-w-0 flex-1">
 <h2 className="text-base sm:text-lg font-semibold text-ink">
 No saved payment methods
 </h2>
 <p className="text-sm text-ink-secondary mt-1.5 leading-relaxed max-w-xl">
 We don’t store card details on your account. When you pay a deposit or invoice,
 Stripe handles the payment securely. Your booking history and receipts stay under
 My Bookings.
 </p>
 <Link
 to="/bookings"
 className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 bg-ink text-white text-sm font-medium rounded-md hover:bg-black transition-colors"
 >
 <Calendar className="w-4 h-4" />
 Go to My Bookings
 <ArrowRight className="w-4 h-4" />
 </Link>
 </div>
 </div>
 </div>
 </div>
 </ClientPageLayout>
 );
};

export default ClientBilling;
